import { Button } from '@aicon-dev/caas-ui';
import { useTranslation } from 'react-i18next';

import { FixedBottomBar } from '~/components/ui/FixedBottomBar';

export const UserFormFooter = (props: { isPending?: boolean }) => {
  const { isPending } = props;
  const { t } = useTranslation('user_info');

  return (
    <FixedBottomBar>
      <Button block type="submit" size="large" color="primary" variant="filled" loading={isPending}>
        {t('user_info:modify')}
      </Button>
    </FixedBottomBar>
  );
};
